<template>
  <div class="pd1-drug">
    <div class="pd1-drug-main">
      <div
        class="pd1-drug-item"
        v-for="item in drugList"
        :key="item.id"
        @click="currentSelect = item"
      >
        <div class="pd1-drug-item-left">
          <div class="pd1-drug-item-select">
            <van-radio-group :value="currentSelect.id">
              <van-radio
                :name="item.id"
                @click="currentSelect = item"
              ></van-radio>
            </van-radio-group>
          </div>
          <div class="pd1-drug-item-content">
            <p>药品规格：{{ item.specs }}</p>
            <p>药品单价：{{ item.price_tag }}</p>
            <p>医保报销比例：{{ item.medical_insurance_ratio }}</p>
          </div>
        </div>
        <div
          class="pd1-drug-item-right"
          @click.stop="edit(item)"
        >
          <i class="el-icon-edit"></i>
        </div>
      </div>
      <div
        class="pd1-drug-item pd1-drug-add"
        @click="add"
      >
        <van-icon
          name="plus"
          size="36px"
        />
      </div>
    </div>
    <div class="pd1-drug-btn">
      <el-button
        type="primary"
        @click="confirm"
      >确认</el-button>
    </div>
    <van-popup
      v-model="addShow"
      position="bottom"
      :style="{ height: '358px' }"
    >
      <div class="pd1-drug-form">
        <div>
          <h3 class="pd1-drug-form-title">
            {{ addForm.id ? '编辑' : '新增' }}药品
          </h3>
          <van-form
            ref="addForm"
            label-width="100px"
          >
            <van-field
              readonly
              clickable
              name="picker"
              :value="addForm.specs"
              label="药品规格："
              placeholder="点击选择药品规格"
              :rules="[{ required: true, message: '请填写药品单价' }]"
              @click="showDrugSpecificationPicker = true"
              right-icon="arrow-down"
            />
            <van-popup
              v-model="showDrugSpecificationPicker"
              position="bottom"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="medicineSpecsColumns"
                @confirm="onDrugSpecificationConfirm"
                @cancel="showDrugSpecificationPicker = false"
              />
            </van-popup>
            <van-field
              v-model="addForm.price"
              name="药品单价"
              label="药品单价："
              placeholder="请输入"
              type="number"
              :rules="[{ required: true, message: '请填写药品单价' }]"
            >
              <template #button>
                /瓶
              </template>
            </van-field>
            <van-field
              v-model="addForm.yibao_baoxiao_ratio"
              name="医保报销比例"
              label="医保报销比例："
              placeholder="请输入"
              type="number"
              :rules="[{ required: true, message: '请填写医保报销比例' }]"
            >
              <template #button>
                %
              </template>
            </van-field>
          </van-form>
        </div>

        <div class="pd1-drug-btn">
          <el-button
            type="primary"
            @click="medicineEdit"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pd1Service from "@/apis/pd1/index.js";
import enums from "@/views/pd1/mixins/enums";
import { setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";

export default {
  data() {
    return {
      radio: "",
      showDrugSpecificationPicker: false,
      addShow: false,
      addForm: {},
      drugList: [],
      currentSelect: {},
      dicineSpecsColumns: [],
    };
  },
  mixins: [enums],

  created() {
    this.medicineList();
  },
  methods: {
    add() {
      this.addForm = {};
      this.addShow = true;
    },
    edit(item) {
      this.addForm = item;
      this.addShow = true;
    },
    confirm() {
      const { currentSelect, drugList } = this;
      let selected = currentSelect;
      if (!currentSelect.id) {
        return;
      }
      drugList.forEach((item) => {
        if (item.id === currentSelect.id) {
          selected = item;
        }
      });
      setStorageExpire(
        CONFIG_STORAGE.PD1_DRUG,
        {
          drugstore_id: this.$route.query.id,
          ...selected,
        },
        60 * 24
      );
      this.$router.go(-1);
    },
    init() {
      const { pd1EnumsMap } = this;
      this.medicineSpecsColumns = pd1EnumsMap.medicine_specs_typeArr;
    },
    async medicineEdit() {
      const { addForm } = this;
      let err = "";
      try {
        await this.$refs.addForm.validate();
      } catch (e) {
        err = e;
      }

      if (err) return;
      const params = {
        drugstore_id: this.$route.query.id,
        ...addForm,
      };
      pd1Service.medicineEdit(params).then(() => {
        this.addShow = false;
        this.medicineList();
      });
    },
    medicineList() {
      const params = {
        drugstore_id: this.$route.query.id,
      };
      pd1Service.medicineList(params).then((res) => {
        this.drugList = res.data;
        console.log(res);
      });
    },
    onDrugSpecificationConfirm(value) {
      const { addForm } = this;
      addForm.specs = value.name;
      this.showDrugSpecificationPicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pd1-drug {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.pd1-drug-btn {
  padding: 20px 15px;
  .el-button {
    width: 100%;
  }
}
.pd1-drug-main {
  padding: 20px 15px;
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
}
.pd1-drug-item {
  padding: 20px;
  border: 1px solid #333;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
  .pd1-drug-item-left {
    display: flex;
    align-items: center;
  }
  .pd1-drug-item-select {
    margin-right: 10px;
  }
  .pd1-drug-item-right {
    font-size: 24px;
  }
}
.pd1-drug-add {
  height: 100px;
  justify-content: center;
  align-items: center;
}
.pd1-drug-form {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}
.pd1-drug-form-title {
  text-align: center;
}
</style>